import Loading from './Loading.jsx';

export default Loading;
